import Vue from "vue";
import {Component} from "vue-property-decorator";
import * as AtErrorEvent from "../modules/AtErrorEvent";
import {SnackMsg} from "@/modules/models";
import SnackEvent from "@/modules/SnackEvent";

@Component
export default class CommonBase extends Vue {

    /**
     * Helper to emit custom error events from components. Will be caught by ErrorHandler further up.
     * @param {Error} err
     */
    emitError(err: Error) {
        const event = AtErrorEvent.create(err);
        this.$el.dispatchEvent(event);
    }

    /**
     * Generate Promise that listens for the first triggered event of given name, that also has event data of given type.
     * @param {Vue} el Element that will trigger the event
     * @param {string} event Name of event that will be triggered
     * @returns {Promise<R>} Promise that resolves when event with given data type is caught
     */
    static oneEventPromise<R>(el: Vue, event: string): Promise<R> {
        return new Promise<R>((resolve) => {
            el.$once(event, resolve);
        });
    }

    get mobileUi() {
        return this.$vuetify.breakpoint.xs;
    }

    emitSnack(msg: string, color?: string) {
        const snack = new SnackMsg(msg, color);
        const ev = new SnackEvent(snack);
        if(this.$el) {
            this.$el.dispatchEvent(ev);
        } else if(window) {
            window.dispatchEvent(ev);
        }
    }
}

